"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RouteDetails = RouteDetails;
var _react = _interopRequireDefault(require("react"));
function RouteDetails(_ref) {
  var destinationCity = _ref.destinationCity,
    destinationTerminal = _ref.destinationTerminal,
    originCity = _ref.originCity,
    originTerminal = _ref.originTerminal,
    routeContentRef = _ref.routeContentRef,
    testId = _ref.testId;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-nowrap gap-x-4 md:flex-col md:gap-y-4",
    "data-testid": testId,
    ref: routeContentRef,
    "data-sentry-component": "RouteDetails",
    "data-sentry-source-file": "RouteDetails.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex min-w-max flex-none gap-1 md:flex-col"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-base leading-[1.2] font-semibold text-gray-600 md:text-xl"
  }, originTerminal), originCity && originCity !== originTerminal && /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-base leading-tight text-gray-400"
  }, originCity)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex min-w-max flex-none gap-1 md:flex-col"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-base leading-[1.2] font-semibold text-gray-600 md:text-xl"
  }, destinationTerminal), destinationCity && destinationCity !== destinationTerminal && /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-base leading-tight text-gray-400"
  }, destinationCity)));
}